export let ViewArchiveErrorType = /*#__PURE__*/function (ViewArchiveErrorType) {
  ViewArchiveErrorType["MIME_TYPE_ERROR"] = "MIME_TYPE_ERROR";
  ViewArchiveErrorType["HTTP_MIME_TYPE_ERROR"] = "HTTP_MIME_TYPE_ERROR";
  ViewArchiveErrorType["NO_ARCHIVE"] = "NO_ARCHIVE";
  ViewArchiveErrorType["DOWNLOAD_ERROR"] = "DOWNLOAD_ERROR";
  ViewArchiveErrorType["PARSE_ERROR"] = "PARSE_ERROR";
  return ViewArchiveErrorType;
}({});

/**
 *
 * Data needed to see any archive must be in one of the
 * ViewArchiveData interface accepted formats:
 * File, Blob, Data Url, HTTP Url, Static Url, Base64, UInt8Array
 *
 */